import brand1 from "../../assets/logos/Logo Ekimak.png";
import brand2 from "../../assets/logos/Logo Fuencanto.png";
import brand3 from "../../assets/logos/Logo Guerreras Yurbaco.png";
import brand4 from "../../assets/logos/Logo Hexakom.png";
import brand5 from "../../assets/logos/Logo Metalvan.png";
import brand6 from "../../assets/logos/Logo Murano.png";
import brand7 from "../../assets/logos/Logo Nuhome.png";
import brand8 from "../../assets/logos/Logo Palmanova.png";
import brand9 from "../../assets/logos/Logo Santa M.png";
import brand10 from "../../assets/logos/Logo Vittoria.png";
import brand11 from "../../assets/logos/Logo coralina construcciones.png";
import brand12 from "../../assets/logos/Logo fundación Dame esos 5.png";
import brand13 from "../../assets/logos/LogoAmarú.png";

export const brandsCollabs = "Marcas con las que he trabajado";

export const brandListLeft = [
  [brand1, brand2, brand3, brand4, brand5, brand6],
  [brand1, brand2, brand3, brand4, brand5, brand6],
];

export const brandListRight = [
  [brand7, brand8, brand9, brand10, brand11, brand12, brand13],
  [brand7, brand8, brand9, brand10, brand11, brand12, brand13],
];
